import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_TIMELINES').plugin(axiosPlugin, {template: "array"});

let fetchUserTimelinesAction = redux.fetchActionGet();

redux.reducerForType('ADD', (state,payload) => {
    let newState = {...state};
    newState.data.unshift({owner : payload.data.owner, parentKind: "Status", parentId: payload.data, createdAt: Date.now(), right: "private", _id: Math.random() });
    newState.total++;
    return newState;
});

redux.reducerForType('DELETE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState.data = newState.data.filter(item => item.parentId && item.parentId._id.toString() !== payload.data._id.toString());
        newState.total--;
        if(newState.total < 0){
            newState.total = 0;
        }
    }
    return newState;
});


redux.reducerForType('INCREMENT_COMMENT', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState.data = newState.data.map(item => {
            if(item.parentId && item.parentId._id.toString() === payload.data.parentId.toString()){
                item = {
                    ...item,
                    parentId : {
                        ...item.parentId,
                        count : {
                            ...item.parentId.count,
                            comment : item.parentId.count.comment + 1
                        }
                    }
                };
            }
            return item;
        });
    }
    return newState;
});

redux.reducerForType('DECREMENT_COMMENT', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState.data = newState.data.map(item => {
            if(item.parentId && item.parentId._id.toString() === payload.data.parentId.toString()){
                item = {
                    ...item,
                    parentId : {
                        ...item.parentId,
                        count : {
                            ...item.parentId.count,
                            comment : item.parentId.count.comment - 1
                        }
                    }
                };
            }
            return item;
        });
    }
    return newState;
});

// redux.reducerForType('UPDATE', (state,payload) => {
//     let newState = {...state};
//     if(payload.data && payload.data._id){
//         newState.data = newState.data.map(item => {
//             if(item.parentId._id.toString() === payload.data._id.toString()){
//                 item = {owner : payload.data.owner, parentKind: "Status", parentId: payload.data, updatedAt: Date.now(), right: "private" };
//             }
//             return item;
//         });
//     }
//     return newState;
// });

redux.reducerForType('UPDATE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState.data = newState.data.map(item => {
            if(item.parentId && item.parentId._id.toString() === payload.data._id.toString()){
                item.parentId = payload.data;
            }
            return item;
        });
    }
    return newState;
});

export const fetchUserTimelines = (userId, query = {}, more = false, privateFeed = false) => fetchUserTimelinesAction(`/users/${userId}/timelines/${privateFeed ? 'private' : 'public'}?${queryString.stringify(query)}`, null, {more});
export const resetUserTimelines = () => redux.actions.reset();

export const userTimelines = redux.reducer();